



















import { SdsButton } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'BetBuilderSummaryFooter',
    props: {
        areAnyOddsSelectionsInactive: {
            type: Boolean,
            required: true,
        },
        inactiveSelectionsCount: {
            type: Number,
            required: false,
            default: 0,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        totalOddsPrice: {
            type: Number,
            required: true,
        },
    },
    emits: ['onSubmit'],
    components: {
        SdsButton,
    },
});
